import React, { useCallback } from 'react';
import { ReportType } from '~/components/Admin';
import { AdminServiceEvents, ServicesContext } from '~/services';
import { defaultApiResponseHandler } from '~/util';

export const useCreateReport = (events: AdminServiceEvents) => {
    const services = React.useContext(ServicesContext);

    const createReport = useCallback(
        async (data: Partial<ReportType>) => {
            try {
                await services.api.call({
                    method: 'post',
                    url: `/api/reports`,
                    data,
                });
                services.events.publish(events.report_list_updated);
            } catch (error) {
                throw defaultApiResponseHandler(error);
            }
        },
        [services.api, services.events, events.report_list_updated]
    );

    return createReport;
};
